import { initMulti } from './multi-methods.js';
import { type, defaultTo, defaultToEmptyStr } from './base.js';
import { t } from '../kioskStore/js/localization.js';

window.defaultTo = defaultTo;
window.defaultToEmptyStr = defaultToEmptyStr;

export const show = initMulti('show');
export const hide = initMulti('hide');

show.addMethod(['$Modal'], (o) => $(o.cssPath).modal('show'));
hide.addMethod(['$Modal'], (o) => $(o.cssPath).modal('hide'));

show.addMethod(['$Button'], (o) => $(o.cssPath).show());
hide.addMethod(['$Button'], (o) => $(o.cssPath).hide());

export const onShowOnce = initMulti('onShow');

onShowOnce.addMethod(['Function', '$Modal'], (cb, o) => $(o.cssPath).one('shown.bs.modal', cb));

export const onHideOnce = initMulti('onHideOnce');

onHideOnce.addMethod(['Function', '$Modal'], (cb, o) => $(o.cssPath).one('hidden.bs.modal', cb));

export const disable = initMulti('disable');
export const enable = initMulti('enable');

disable.addMethod(['$Button'], (o) => {
  document.querySelector(o.cssPath).disabled = true;
});
enable.addMethod(['$Button'], (o) => {
  document.querySelector(o.cssPath).disabled = false;
});

export const onClickOnce = initMulti('onClickOnce');
export const onClick = initMulti('onClick');

onClickOnce.addMethod(['Function', '$Button'], (cb, o) => $(o.cssPath).one('click', cb));
onClick.addMethod(['Function', '$Button'], (cb, o) => $(o.cssPath).on('click', cb));
onClickOnce.addMethod(['AsyncFunction', '$Button'], (cb, o) => $(o.cssPath).one('click', cb));
onClick.addMethod(['AsyncFunction', '$Button'], (cb, o) => $(o.cssPath).on('click', cb));

const videoSrc = {};
const getSrcVideo = initMulti('getSrcVideo', () => process.env.NODE_ENV);

getSrcVideo.addMethod(['autotest'], (video) => videoSrc[video.cssPath] || null);
getSrcVideo.defaultMethod((video) => document.querySelector(video).src || null);

const setSrcVideo = initMulti('setSrcVideo', () => process.env.NODE_ENV);

setSrcVideo.addMethod(['autotest'], (mediaStream, video) => {
  videoSrc[video.cssPath] = mediaStream;
});
setSrcVideo.defaultMethod((mediaStream, video) => {
  document.querySelector(video.cssPath).srcObject = mediaStream;
});

export const getSrc = initMulti('getSrc');
export const setSrc = initMulti('setSrc');

getSrc.addMethod(['$Video'], getSrcVideo);
setSrc.addMethod(['MediaStream', '$Video'], setSrcVideo);

export const play = initMulti('play');

play.addMethod(['$Video'], (video) => {
  const videoElem = document.querySelector(video.cssPath);
  videoElem.onloadedmetadata = () => {
    videoElem.play().catch((e) => {
      console.error('play video error', e);
    });
  };
});

export const subscribe = (event, cb, emmiter) => emmiter.subscribe(event, cb);
export const unsubscribe = (event, cb, emmiter) => emmiter.unsubscribe(event, cb);
export const once = (event, cb, emmiter) => emmiter.once(event, cb);

export const render = initMulti('render', (elem) => elem.cssPath);

render.addMethod('#btn-search-by-selfie', () => {
  $('#kioskActionsSecondCont').html(
    `<button id="btn-search-by-selfie" class="btn btn-block btn-info" role="button">${t(
      'welcome-selfie-modal-title'
    )}</button>`
  );
});

render.addMethod('#btn-cancel-search-by-selfie', () => {
  $('#kioskActionsSecondCont').html(
    `<button id="btn-cancel-search-by-selfie" class="btn btn-primary btn-block" role="button">&lt; ${t(
      'welcome-back-to-gallery-btn'
    )}</button>`
  );
});

export const getValue = initMulti('getValue', (name, itemType) => {
  if (name === 'stHtmlUrl' && itemType === 'queryString') {
    return 'queryString-stHtmlUrl';
  }
  if (itemType.hasOwnProperty('cssPath') && itemType.type === '$Checkbox' && name === 'value') return 'html-checkbox';
  if (itemType.hasOwnProperty('cssPath') && itemType.type === '$InputNumber' && name === 'value') return 'html-number';
  if (itemType.hasOwnProperty('cssPath')) return 'html';
  return itemType;
});

export const hasValue = initMulti('hasValue', (_, itemType) =>
  itemType.hasOwnProperty('cssPath') ? 'html' : itemType
);
export const setValue = initMulti('setValue', (name, __, itemType) => {
  if (itemType.hasOwnProperty('cssPath') && itemType.type === '$Select' && name === 'options')
    return 'html-select-options';
  if (itemType.hasOwnProperty('cssPath') && itemType.type === '$InputTags') return 'app-input-tags';
  if (itemType.hasOwnProperty('cssPath') && itemType.type === '$Checkbox' && name === 'value') return 'html-checkbox';
  if (itemType.hasOwnProperty('cssPath') && name === 'content') return 'html-content';
  if (itemType.hasOwnProperty('cssPath')) return 'html';
  return itemType;
});
export const maybeSetValue = (name, value, itemType) => {
  if (value !== null && value !== undefined) {
    return setValue(name, value, itemType);
  }
  return;
};

window.getValue = getValue;
window.setValue = setValue;
window.maybeSetValue = maybeSetValue;

getValue.addMethod('queryString', (name) => new URLSearchParams(document.location.search).get(name));
getValue.addMethod('queryString-stHtmlUrl', () =>
  decodeURIComponent(new URLSearchParams(document.location.search).get('stHtmlUrl'))
);
getValue.addMethod('localStorage', (name) => localStorage.getItem(name));
getValue.addMethod('html', (name, elem) => $(elem.cssPath).prop(name));
getValue.addMethod('html-checkbox', (_, elem) => $(elem.cssPath).prop('checked'));
getValue.addMethod('html-number', (_, elem) => Number($(elem.cssPath).prop('value')));
hasValue.addMethod('queryString', (name) => new URLSearchParams(document.location.search).has(name));
hasValue.addMethod('localStorage', (name) => localStorage.getItem(name) !== null);
hasValue.addMethod('html', (name, elem) => $(elem.cssPath).prop(name) !== null);
setValue.addMethod('localStorage', (name, value) => localStorage.setItem(name, value));
setValue.addMethod('html', (name, value, elem) => {
  $(elem.cssPath).prop(name, value);
});
setValue.addMethod('html-content', (_, value, elem) => {
  $(elem.cssPath).html(value);
});
setValue.addMethod('html-checkbox', (_, value, elem) => {
  $(elem.cssPath).prop('checked', value);
});
setValue.addMethod('html-select-options', (_, options, elem) => {
  const htmlString = options.map((value) => `<option>${value}</option>`).reduce((acc, option) => acc + option, '');
  $(elem.cssPath).html(htmlString);
});
setValue.addMethod('app-input-tags', (_, options, elem) => {
  $(elem.cssPath).importTags(options);
});

export const saveToStorage = initMulti('saveToStorage', (...args) => {
  if (args.length === 1) {
    const [from] = args;
    return [type(from), 'queryString'];
  }

  if (args.length === 2) {
    const [from, to] = args;
    return [type(from), type(to), 'queryString'];
  }

  const [from, to, storage] = args;
  return [type(from), type(to), storage];
});

saveToStorage.addMethod(['String', 'queryString'], (fromTo) =>
  setValue(fromTo, getValue(fromTo, 'queryString'), 'localStorage')
);
saveToStorage.addMethod(['String', 'String', 'queryString'], (from, to) =>
  setValue(to, getValue(from, 'queryString'), 'localStorage')
);
